/* eslint-disable max-len */
import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { useColors } from '@hooks';
import type { IPaymentMethodSvgProps } from './ApplePaySvg';

export function GooglePaySvg({
  contentColor = '$background0',
  ...props
}: IPaymentMethodSvgProps) {
  const colors = useColors();

  return (
    <Svg width={62} height={25} fill="none" {...props}>
      <Path
        d="M28.948 12.172v7.076h-2.26V1.774h5.993c1.519 0 2.814.503 3.874 1.51 1.083 1.005 1.625 2.233 1.625 3.683 0 1.486-.542 2.714-1.625 3.708-1.048.994-2.343 1.485-3.874 1.485h-3.733v.012Zm0-8.246v6.094h3.78c.895 0 1.649-.304 2.237-.9.6-.597.907-1.322.907-2.14 0-.808-.306-1.521-.907-2.118-.588-.62-1.33-.924-2.237-.924h-3.78v-.012ZM44.092 6.897c1.672 0 2.99.445 3.956 1.334.965.889 1.448 2.105 1.448 3.649v7.368h-2.154v-1.66h-.095c-.93 1.368-2.178 2.046-3.732 2.046-1.331 0-2.438-.386-3.333-1.17-.895-.783-1.342-1.754-1.342-2.923 0-1.24.47-2.223 1.413-2.948.942-.736 2.202-1.1 3.768-1.1 1.342 0 2.45.247 3.309.738v-.515c0-.784-.306-1.438-.93-1.988a3.204 3.204 0 0 0-2.19-.819c-1.26 0-2.261.526-2.992 1.59l-1.99-1.239c1.096-1.579 2.72-2.363 4.864-2.363Zm-2.92 8.679c0 .585.247 1.076.753 1.462.495.386 1.083.585 1.754.585.954 0 1.802-.351 2.544-1.053s1.119-1.52 1.119-2.468c-.707-.55-1.684-.83-2.944-.83-.919 0-1.684.222-2.297.655-.623.456-.93 1.005-.93 1.649ZM61.788 7.283 54.252 24.5H51.92l2.803-6.024-4.97-11.193h2.462l3.58 8.585h.047l3.485-8.585h2.461Z"
        fill={colors[contentColor]}
      />
      <Path
        d="M19.958 10.745c0-.732-.066-1.433-.188-2.106h-9.477v3.86h5.458a4.641 4.641 0 0 1-2.026 3.11v2.503h3.25c1.896-1.743 2.983-4.321 2.983-7.367Z"
        fill="#4285F4"
      />
      <Path
        d="M13.727 15.609c-.904.606-2.068.96-3.43.96-2.632 0-4.865-1.761-5.665-4.135h-3.35v2.582a10.095 10.095 0 0 0 9.014 5.518c2.725 0 5.014-.89 6.68-2.422l-3.248-2.503Z"
        fill="#34A853"
      />
      <Path
        d="M4.315 10.518c0-.667.112-1.311.316-1.917V6.019H1.28a9.913 9.913 0 0 0-1.073 4.499c0 1.619.387 3.146 1.073 4.5l3.35-2.583a6.005 6.005 0 0 1-.315-1.917Z"
        fill="#FABB05"
      />
      <Path
        d="M10.296 4.465c1.487 0 2.82.509 3.87 1.503l2.88-2.857C15.297 1.493 13.018.5 10.296.5a10.097 10.097 0 0 0-9.015 5.518l3.351 2.583c.8-2.375 3.033-4.136 5.664-4.136Z"
        fill="#E94235"
      />
    </Svg>
  );
}
